/** Что мешает нажать действие: нет связи с агентом или идёт другое действие. */
export function blockReason(locked: boolean, busy: boolean): string | null {
  if (locked) return 'Нет связи с программой-драйвером'
  if (busy) return 'Подождите: идёт применение'
  return null
}

/** Общие свойства вкладок. */
export interface TabProps {
  /** Нет связи с агентом: действия выключены. */
  locked: boolean
  busy: boolean
}
